import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll/modules';

import { CarLoanForm } from '@eika-felles/kyc-declaration-lib';

interface Props {
    ssn: string;
    previousEvent?: () => void;
    previousButtonText?: string;
    completeEvent: (status: string) => void;
    completeButtonUrl?: string;
}

const KycForm = ({
    ssn,
    previousEvent,
    previousButtonText = 'Tilbake',
    completeEvent,
    completeButtonUrl,
}: Props): JSX.Element => {
    useEffect(() => {
        setTimeout(() => {
            scroll.scrollToTop();
        }, 200);
    }, []);
    return (
        <CarLoanForm
            publicId={ssn}
            goBackCallback={previousEvent}
            goBackText={previousButtonText}
            statusCallback={completeEvent}
            onFinishRedirectURL={completeButtonUrl}
        />
    );
};
export default KycForm;
